import { render, staticRenderFns } from "./CheckoutBlock.vue?vue&type=template&id=65056d78"
import script from "./CheckoutBlock.vue?vue&type=script&lang=js"
export * from "./CheckoutBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports